<template>
  <div class="reset-container">
    <form id="reset" v-on:submit.prevent="reset()" novalidate="true">
      <div class="form-description">Upišite novu lozinku</div>

      <div class="form-field">
        <input
          v-if="!newPasswordShown"
          type="password"
          v-model="newPassword"
          v-on:change="validatePassword"
          v-bind:class="!isPasswordValid ? 'password-error' : ''"
        />
        <input
          v-else
          type="text"
          v-model="newPassword"
          v-on:change="validateFPassword"
          v-bind:class="!isPasswordValid ? 'password-error' : ''"
        />
        <img
          v-if="!newPasswordShown"
          src="../assets/app-icons/profile/hide-password.svg"
          class="visibility"
          v-on:click="newPasswordShown = true"
        />
        <img
          v-else
          src="../assets/app-icons/profile/show-password.svg"
          class="visibility show"
          v-on:click="newPasswordShown = false"
        />
        <label for="password" v-bind:class="newPassword ? 'field-filled' : ''">Nova lozinka</label>
        <div class="error" v-bind:style="{ display: isPasswordValid ? 'none' : 'block' }">
          Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.
        </div>
      </div>

      <div class="form-field">
        <input
          v-if="!newPasswordShown"
          id="repeatedpassword"
          type="password"
          v-model="repeatedNewPassword"
          v-on:change="validateRepeatedPassword"
          v-on:blur="validateRepeatedPassword"
          v-bind:class="!isRepeatedPasswordValid ? 'password-error' : ''"
        />
        <input
          v-else
          id="repeatedpassword"
          type="text"
          v-model="repeatedNewPassword"
          v-on:change="validateRepeatedPassword"
          v-on:blur="validateRepeatedPassword"
          v-bind:class="!isRepeatedPasswordValid ? 'password-error' : ''"
        />
        <label for="repeatedpassword" v-bind:class="repeatedNewPassword ? 'field-filled' : ''">
          Ponovljena nova lozinka
        </label>
        <div class="error" v-bind:style="{ visibility: isRepeatedPasswordValid ? 'hidden' : 'visible' }">
          Upisane lozinke se ne poklapaju.
        </div>
      </div>

      <div class="result" v-if="isResetOver">
        <div class="you-made-it" v-if="didResetSucceed">Lozinka je uspješno promijenjena.</div>
        <div class="error" v-else>
          Niste uspjeli resetirati lozinku. Molimo pokušajte ponovo, ili nas kontaktirajte na
          <a href="mailto:days@dump.hr">e-mail</a>.
        </div>
      </div>

      <div class="actions">
        <button type="submit" class="button" value="submit" v-bind:disabled="!isFormValid()">SPREMI</button>
        <a href="/" class="return-home">Povratak na početnu &#10230;</a>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Reset',
  data() {
    return {
      didResetSucceed: false,
      isResetOver: false,
      newPassword: '',
      newPasswordShown: false,
      repeatedNewPassword: '',
      repeatedNewPasswordShown: false,
      isPasswordValid: true,
      isRepeatedPasswordValid: true,
    };
  },
  methods: {
    validatePassword: function() {
      let pass = this.newPassword;
      this.isPasswordValid = pass && pass.length >= 8 && pass.toLowerCase() !== pass && /\d/.test(pass);
    },
    validateRepeatedPassword: function() {
      this.isRepeatedPasswordValid = this.newPassword === this.repeatedNewPassword;
    },
    isFormValid: function() {
      return (
        this.isPasswordValid &&
        this.isRepeatedPasswordValid &&
        this.newPassword !== '' &&
        this.repeatedNewPassword !== ''
      );
    },
    reset: function() {
      if (this.isFormValid() && this.newPassword === this.repeatedNewPassword)
        this.$axios
          .post(`${this.$API_URL}/user/reset-password`, {
            code: this.$route.query.code,
            newPassword: this.newPassword,
          })
          .then(() => {
            this.didResetSucceed = true;
            this.isResetOver = true;
            setTimeout(() => {
              this.$router.push('/');
            }, 3000);
          })
          .catch(() => {
            this.didResetSucceed = false;
            this.isResetOver = true;
          });
    },
  },
};
</script>

<style scoped>
#reset {
  width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
}

#reset .form-description {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 50px;
  color: white;
}

#reset .form-field {
  margin-bottom: 32px;
}

#reset input {
  position: relative;
  width: 100%;
}

#reset input {
  border: none;
  border-bottom: 1.5px solid #7a8e94;
  font-size: 20px;
  padding: 25px 25px 10px 0;
  color: #1a3c44;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  width: 100%;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
  box-sizing: border-box;
}

#reset .visibility {
  position: absolute;
  right: 0;
  top: 28px;
}

#reset .visibility.show {
  top: 30px;
}

#reset .visibility:hover {
  cursor: pointer;
}

#reset .form-field {
  position: relative;
}

#reset input.password-error {
  color: #d73246;
  border-bottom-color: #d73246;
}

#reset input:focus {
  border-bottom: 1.5px solid #5ec4bc;
  color: #5ec4bc;
}

#reset label {
  position: absolute;
  color: white;
  font-size: 20px;
  left: 0;
  top: 25px;
  transition: all 0.1s ease;
  pointer-events: none;
}

#reset input:focus ~ label,
#reset label.field-filled {
  font-size: 16px;
  top: 0;
}

#reset .result {
  margin-top: 0;
  margin-bottom: 32px;
}

#reset .error {
  margin-top: 5px;
  font-size: 14px;
  color: #d73246;
  font-weight: normal;
}

#reset .error a {
  text-decoration: none;
  color: #30cec2;
}

#reset .you-made-it {
  color: #30cec2;
}

#reset .actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#reset .button {
  padding: 10px 70px;
}

#reset .return-home {
  font-size: 20px;
  color: #ffffff;
  text-decoration: none;
}

@media screen and (max-width: 700px) {
  #reset {
    width: 100%;
    padding: 50px 25px;
    top: 0;
    left: 0;
    position: relative;
    transform: translate(0, 0);
  }

  #reset .button {
    padding: 10px 50px;
    font-size: 16px;
  }

  #reset .return-home {
    font-size: 16px;
  }
}

@media screen and (max-width: 425px) {
  #reset .button {
    padding: 10px 30px;
  }

  #reset .return-home {
    width: 96px;
  }
}
</style>
